import { createFileRoute, Outlet } from '@tanstack/react-router'
import { ProcessData } from 'pages/processData/ProcessData'

export const Route = createFileRoute('/process-data/{-$siteID}/')({
  component: ProcessDataRouteComponent,
  staticData: {
    title: 'Process Data',
    layout: {
      enableScrolling: true,
      enforceMaxWidth: true,
    },
  },
})

function ProcessDataRouteComponent() {
  const params = Route.useParams()
  const siteID = params.siteID

  if (!siteID) {
    return <Outlet />
  }

  return <ProcessData />
}
